<template>
  <div>
    <div v-for="(item,index) in listArr" :key="index">
      <el-form>
        <el-row>
          <el-col :span="16">
            <el-col :span="7" style="padding-left:0px;">
              <el-col :span="20">
                <el-form-item class="form-itemL">{{item.shipName}}：{{item.shipPrice|priceFilter}}</el-form-item>
              </el-col>
            </el-col>
            <el-col :span="9" style="padding-left:0px;">
              <el-col :span="20">
                <el-form-item label="本期货款：" label-width="100px" class="form-itemL">
                  <el-input-number
                    :controls='false'
                    v-if="contractOverview.signState===1"
                    v-model="item.shipTotal"
                    :precision="2"
                    :min="0"
                    :placeholder="'≥'+item.totPrice"
                    :disabled="index===listArr.length-1"
                    @blur="onBlurShipTotal(index)"
                  ></el-input-number>
                  <span v-else>{{item.shipTotal|priceFilter}}</span>
                </el-form-item>
              </el-col>
            </el-col>
            <el-col :span="8">
              <el-form-item label="预计付款时间：" label-width="100px" class="form-itemL">
                <el-date-picker
                  v-if="contractOverview.signState===1"
                  v-model="item.shipPayDate"
                  value-format="yyyy-MM-dd"
                  type="date"
                  placeholder="选择日期"
                  :picker-options="$store.state.Sell.time"
                ></el-date-picker>
                <span v-else>{{item.shipPayDate}}</span>
              </el-form-item>
            </el-col>
          </el-col>
          <el-col :span="8" style="text-align:right;" v-show="contractOverview.signState===1">
            <el-form-item class="form-itemL">
              <el-button
                @click="onAdjustProduct(item.orderShipmentQueryVoList,index)"
                type="primary"
              >调整产品</el-button>
              <el-button @click="onDelete(index)" type="danger" plain>删除期货</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <el-table
        :class="index===listArr.length-1?'tableNex':'tableArr'"
        ref="custromTableRef"
        :data="item.orderShipmentQueryVoList"
        tooltip-effect="dark"
        :header-cell-style="tableHeader"
        v-loading="loadingTable"
        element-loading-text="拼命加载中请稍后..."
        element-loading-spinner="el-icon-loading"
        @select="selectRowClick"
        @select-all="selectAll"
        @selection-change="selectChange(index)"
        border
      >
        <el-table-column fixed type="selection"></el-table-column>
        <el-table-column prop="brandName" label="品牌" show-overflow-tooltip></el-table-column>
        <el-table-column prop="seriesName" label="系列" show-overflow-tooltip></el-table-column>
        <el-table-column prop="proName" label="产品名称" show-overflow-tooltip></el-table-column>
        <el-table-column prop="proType" label="型号" show-overflow-tooltip>
          <template slot-scope="scope">
            <div
              class="approval line-limit-length"
              @click="onProductDetail(scope.row)"
            >{{ scope.row.proType }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="orderNumber" label="订货号" show-overflow-tooltip></el-table-column>
        <el-table-column prop="cbNumber" label="数量"></el-table-column>
        <el-table-column prop="cbUnit" label="单位"></el-table-column>
        <el-table-column label="货期" width="110">
          <template slot-scope="scope">
            <el-row :gutter="5" v-if="contractOverview.signState===1">
              <el-col :span="20">
                <el-input
                  oninput="value=value.replace(/^(0+)|[^\d]+/g,'')"
                  v-model="scope.row.cbExtimeValue"
                ></el-input>
              </el-col>
              <el-col :span="4">天</el-col>
            </el-row>
            <span v-else>{{scope.row.cbExtimeValue}}天</span>
          </template>
        </el-table-column>
        <el-table-column prop="cbRemind" label="提醒" width="125">
          <template slot-scope="scope">
            <span
              class="approval"
              @click="cbRemindSet(scope.$index,index)"
              v-if="contractOverview.signState===1"
            >{{scope.row.cbRemind||'请设置提醒时间'}}</span>
            <span v-else>{{ scope.row.cbRemind|dateFilter }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="cbPrice" label="销售单价">
          <template slot-scope="scope">{{ scope.row.cbPrice|priceFilter }}</template>
        </el-table-column>
        <el-table-column prop="cbDiscount" label="折扣">
          <template slot-scope="scope">{{ scope.row.cbDiscount|perCentFilter }}</template>
        </el-table-column>
        <el-table-column prop="cbRate" label="毛利率" show-overflow-tooltip>
          <template slot-scope="scope">{{ scope.row.cbRate|perCentFilter }}</template>
        </el-table-column>
        <el-table-column prop="cbTotal" label="销售总额">
          <template slot-scope="scope">{{ scope.row.cbTotal|priceFilter }}</template>
        </el-table-column>
        <el-table-column prop="cbUnitPrice" label="供货单价">
          <template slot-scope="scope">{{ scope.row.cbUnitPrice|priceFilter }}</template>
        </el-table-column>
        <el-table-column prop="cbUnitTotal" label="供货总额">
          <template slot-scope="scope">{{ scope.row.cbUnitTotal|priceFilter }}</template>
        </el-table-column>
        <el-table-column prop="mark" label="备注" show-overflow-tooltip width="120"></el-table-column>
        <el-table-column prop="cbFacePrice" label="面价">
          <template slot-scope="scope">{{ scope.row.cbFacePrice|priceFilter }}</template>
        </el-table-column>
        <el-table-column label="询价来源">
          <template
            slot-scope="scope"
          >{{scope.row.cbPriceSource===4?'其他':scope.row.cbPriceSource===2?'人工':scope.row.cbPriceSource===3?'特价审批':'系统'}}</template>
        </el-table-column>
      </el-table>
    </div>
    <div class="box-add-message" v-show="contractOverview.signState===1" @click="onSetFutures()">
      <div class="el-icon-circle-plus-outline"></div>
      <div>设置期货</div>
    </div>
    <!------------ 设置提醒 ------------>
    <batch-set-remindDialog ref="batchSetRemindDialogRefs" @onSetTime="onSetTime"></batch-set-remindDialog>
    <!------------ 调整产品 ------------>
    <set-futures-dialog ref="setFuturesDialogRefs" :title="title" @addProductList="addProductList"></set-futures-dialog>
  </div>
</template>
<script>
import { SectionToChinese } from '@/util/tool'
import setFuturesDialog from '../../dialog/setFuturesDialog'
import batchSetRemindDialog from '@/components/SetReminders/batchSetRemindDialog'
export default {
  props: [
    'futuresPaymentList',
    'goodAmountPer',
    'goodAmount',
    'productList',
    'contractOverview'
  ],
  components: {
    'batch-set-remindDialog': batchSetRemindDialog,
    'set-futures-dialog': setFuturesDialog
  },
  data () {
    return {
      listArr: [],
      checkList: [], // 列表选中的数据
      loadingTable: false,
      tempList: [], // 缓存的原始数据
      title: '', // 设置期货弹窗标题
      index: null, // 期货 点击设置提醒时间 下标
      listChildrenIndex: 0, // 小数组的小标(列表)
      changeIndex: -1 // 取消全选的时候触发
    }
  },
  watch: {
    futuresPaymentList: {
      handler (val) {
        if (val === null) {
          this.listArr = []
        } else {
          val.forEach((ele) => {
            ele.orderShipmentQueryVoList.forEach((item) => {
              item.id = item.ccId
            })
          })
          this.listArr = JSON.parse(JSON.stringify(val))
        }
      },
      deep: true
    }
  },
  methods: {
    onProductDetail (row) {
      this.$router.push({ name: 'productDetails', query: { id: row.proId } })
    },
    cbRemindSet (index, i) {
      // 设置提醒时间 显示 弹框
      this.index = i
      this.$refs.batchSetRemindDialogRefs.onInitial(index)
    },
    onSetTime (val, i) {
      // 单独一项 设置提醒
      if (this.listArr[this.index].orderShipmentQueryVoList[i].cbExtimeValue) {
        this.listArr[this.index].orderShipmentQueryVoList[i].cbRemind = val
      } else {
        this.$message.error('请设置货期')
      }
    },
    onSetFutures (val) {
      // 设置期货
      this.tempList = JSON.parse(JSON.stringify(this.productList))
      if (this.listArr.length > 0) {
        this.tempList.forEach((ele, index) => {
          this.listArr.forEach((params) => {
            params.orderShipmentQueryVoList.forEach((item) => {
              if (ele.id === item.id) {
                ele.cbNumber -= item.cbNumber
              }
            })
          })
          ele.max = ele.cbNumber
        })
        for (let i = 0; i < this.tempList.length; i++) {
          if (this.tempList[i].cbNumber === 0) {
            this.tempList.splice(i, 1)
            i--
          }
        }
      } else {
        this.tempList.forEach((ele) => {
          ele.max = ele.cbNumber
        })
      }
      if (val) {
        this.title = '调整产品' // 调整产品弹窗标题
        return
      }
      this.title = '设置期货' // 设置期货弹窗标题
      this.$refs.setFuturesDialogRefs.onInitial(this.tempList)
    },
    onAdjustProduct (arr, index) {
      // 调整产品
      this.onSetFutures(true)
      this.tempList.push(...arr)
      this.tempList = this.tempList.reduce((obj, item) => {
        const find = obj.find((i) => i.id === item.id)
        const _d = item
        find ? (find.cbNumber += item.cbNumber) : obj.push(_d)
        return obj
      }, [])
      arr.forEach((ele) => [
        this.tempList.forEach((item) => {
          if (item.id === ele.id) {
            ele.max = item.cbNumber
          }
        })
      ])
      this.$refs.setFuturesDialogRefs.onInitial(this.tempList, arr, index)
    },
    // 弹框自定义事件
    addProductList (val) {
      if (val.paramsIndex === undefined) {
        this.listArr.push(val)
      } else {
        for (let i = 0; i < this.listArr.length; i++) {
          if (val.paramsIndex === i) {
            this.listArr[i].orderShipmentQueryVoList =
              val.orderShipmentQueryVoList
          }
        }
      }
      this.listArr.forEach((ele, index) => {
        ele.shipPrice = ele.orderShipmentQueryVoList.reduce((tot, val) => {
          return tot + val.cbTotal
        }, 0)
        ele.totPrice = ((ele.shipPrice * this.goodAmountPer) / 100).toFixed(2)
        const ind = SectionToChinese(index + 1)
        ele.shipName = ind + '期产品报价'
      })
    },
    // 本期货款计算
    onBlurShipTotal (index) {
      let nums = 0
      const ind = this.listArr.length - 1
      this.listArr.forEach((ele, i) => {
        if (i !== this.listArr.length - 1) {
          nums += ele.shipTotal ? Number(ele.shipTotal) : 0
        }
      })
      if (nums > this.goodAmount) {
        this.listArr[index].shipTotal = null
        this.$set(this.listArr[ind], 'shipTotal', null)
      } else {
        this.$set(this.listArr[ind], 'shipTotal', +(this.goodAmount - nums).toFixed(2))
      }
    },
    // 设置头部背景色
    tableHeader ({ rowIndex }) {
      return this.$tableHeader(rowIndex)
    },
    // 批量选中设置提醒
    selectRowClick (selection, row) {
      row.isBool = !row.isBool
      this.$emit('onFuturesCheckList', this.listArr)
    },
    // 全选
    selectAll (selection) {
      if (selection.length > 0) {
        if (selection.length > 0) {
          selection.forEach((item) => {
            item.isBool = !item.isBool
          })
        }
      } else {
        // 取消全选是找到全选的列表下标
        for (let i = 0; i < this.listArr.length; i++) {
          if (this.changeIndex === i) {
            this.listArr[i].orderShipmentQueryVoList.forEach((item) => {
              item.isBool = false
            })
          }
        }
      }
      this.$emit('onFuturesCheckList', this.listArr)
    },
    // 用来取消全选是找到全选的列表下标
    selectChange (index) {
      this.changeIndex = index
    },
    // 删除期货
    onDelete (index) {
      this.listArr.splice(index, 1)
    },
    // 批量设置提醒
    onSetReminders (val) {
      let isF = false
      this.listArr.forEach((item) => {
        item.orderShipmentQueryVoList.forEach((res) => {
          if (res.isBool === true) {
            if (res.cbExtimeValue) {
              res.cbRemind = val
            } else {
              isF = true
            }
          }
        })
      })
      if (isF) {
        this.$message.error('请设置货期')
      }
    },
    onChildData () {
      this.onSetFutures(true)
      let show = false
      if (this.tempList.length !== 0) {
        show = true
      }
      this.$emit('getParentData', this.listArr, show)
    }
  }
}
</script>
<style lang="scss">
.form-itemL {
  margin-bottom: 14px !important;
}
.tableArr {
  margin: 0 0 30px;
}
.tableNex {
  margin: 0 0 20px;
}
</style>
